import { atom, atomFamily } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';

export const staticEntityFormData = [
  {
    name: 'entity_id',
    label: '',
    type: 'text',
    placeholder: 'Enter your fullname',
    isRequired: false,
    hasOptions: false,
    options: [],
  },
];

export const entityTableStateAtom = atom({
  key: RecoilAtomKey.entityTableStateKey,
  default: {
    cache: {},
    totalCountCache: {},
    filters: {
      limit: 20,
      search: '',
      page: 0,
      sortOrder: 'desc',
      sortField: 'created_at',
      parentEntityFormId: '',
    },
    isLoading: false,
  },
});

export const entityFormsStateAtomFamily = atomFamily({
  key: 'entityFormsStateAtomFamily',
  default: {
    cache: {},
    totalCountCache: {},
    filters: {
      limit: 20,
      search: '',
      page: 1,
      sortOrder: 'desc',
      sortField: 'created_at',
      entityFormId: '',
      parentEntityFormId: '',
    },
    isLoading: false,
  },
});
export const entityDetailsStateAtomFamily = atomFamily({
  key: 'entityDetailsStateAtomFamily',
  default: {
    cache: {},
    totalCountCache: {},
    filters: {
      limit: 20,
      search: '',
      page: 1,
      sortOrder: 'desc',
      sortField: 'created_at',
      entityFormId: '',
      // parentFormId:'',
    },
    isLoading: false,
  },
});

export const entityPreviewDataAtom = atom({
  key: RecoilAtomKey.entityPreviewKey,
  default: {},
});

export const entityDropdownAtom = atomFamily<any[], string>({
  key: RecoilAtomKey.entityDropdownAtomFamilyKey,
  default: [],
});
// export const entityFormMappingAtom = atom({
//   key: RecoilAtomKey.entityFormMappingKey,
//   default: {},
// });